import React, { useState, useEffect } from "react";
import { Select, Checkbox } from "antd";
import produce from "immer";

// Aplana opciones simples y agrupadas a un array plano de items con value
const flattenOptions = (opts) =>
  (opts ?? []).flatMap((o) => (o.options ? o.options : [o]));

const CampoSelect = ({ options, valoresIniciales, onSeleccionar, onQuitar, showSelectAll = false }) => {
  const [valoresSeleccionados, setValoresSeleccionados] = useState([]);
  const [itemsSeleccionados, setItemsSeleccionados] = useState([]);

  const flatOptions = flattenOptions(options);
  const total = flatOptions.length;
  const cantSeleccionados = valoresSeleccionados?.length ?? 0;
  const todosSeleccionados = total > 0 && cantSeleccionados === total;
  const algunosSeleccionados = cantSeleccionados > 0 && !todosSeleccionados;

  const onSelect = (valor, item) => {
    setValoresSeleccionados(produce((draft) => { draft.push(valor); }));
    setItemsSeleccionados(produce((draft) => { draft.push(item); }));
    onSeleccionar([...itemsSeleccionados, item]);
  };

  useEffect(() => {
    const _valoresIniciales = valoresIniciales?.map((v) => v.id);
    setValoresSeleccionados(_valoresIniciales);
    setItemsSeleccionados(valoresIniciales);
    onSeleccionar(valoresIniciales);
  }, [valoresIniciales]);

  const onDeselect = (valor, item) => {
    const quitarCampo = onQuitar(valor, item);
    if (!quitarCampo) {
      setValoresSeleccionados([...valoresSeleccionados]);
    } else {
      setValoresSeleccionados(produce((draft) => {
        const indice = draft.findIndex((v) => v === valor);
        draft.splice(indice, 1);
      }));
      setItemsSeleccionados(produce((draft) => {
        const indice = draft.findIndex((i) => i.id === item.id);
        draft.splice(indice, 1);
      }));
      const items = itemsSeleccionados.slice().filter((i) => i.id !== item.id);
      onSeleccionar([...items]);
    }
  };

  const onToggleSeleccionarTodos = (e) => {
    e.stopPropagation();
    if (todosSeleccionados) {
      setValoresSeleccionados([]);
      setItemsSeleccionados([]);
      onSeleccionar([]);
    } else {
      const allValues = flatOptions.map((o) => o.value);
      setValoresSeleccionados(allValues);
      setItemsSeleccionados(flatOptions);
      onSeleccionar(flatOptions);
    }
  };

  const dropdownRender = (menu) => (
    <>
      {showSelectAll && (
        <div
          style={{ padding: "8px 12px", cursor: "pointer", userSelect: "none", borderBottom: "1px solid #f0f0f0" }}
          onMouseDown={(e) => e.preventDefault()}
          onClick={onToggleSeleccionarTodos}
        >
          <Checkbox
            checked={todosSeleccionados}
            indeterminate={algunosSeleccionados}
            style={{ marginRight: 8, pointerEvents: "none" }}
          />
          {todosSeleccionados ? "Quitar todos" : "Seleccionar todos"}
          {total > 0 && (
            <span style={{ color: "#999", marginLeft: 8, fontSize: "12px" }}>
              ({cantSeleccionados}/{total})
            </span>
          )}
        </div>
      )}
      {menu}
    </>
  );

  return (
    <Select
      mode="multiple"
      placeholder="Seleccione una opción"
      value={valoresSeleccionados}
      onSelect={onSelect}
      options={options}
      onDeselect={onDeselect}
      dropdownRender={dropdownRender}
      showSearch
      filterOption={(input, option) =>
        (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
      }
    />
  );
};

export default CampoSelect;
